import Cookies from 'js-cookie';

export const getCookie = (name: string): string | null => {
  return Cookies.get(name) || null;
};

export const setCookie = (name: string, value: string, days: number = 30): void => {
  Cookies.set(name, value, {
    expires: days,
    sameSite: 'lax',
    secure: import.meta.env.PROD, // true in production (HTTPS), false in dev (HTTP)
    path: '/'
  });
};

export const deleteCookie = (name: string): void => {
  Cookies.remove(name, { path: '/' });
};